/**
 * @file Parse Scan Mode input: pick-sheet URLs vs paper-invoice barcodes.
 * Paper invoices scan as a zero-padded digit string plus a trailing check
 * digit, e.g. "0000298126467" for invoice 29812646.
 */

/**
 * True when the scanned value is a bidder pick-sheet / scan-page URL.
 * @param {unknown} value
 * @returns {boolean}
 */
export function isPickSheetScanUrl(value) {
  const s = String(value ?? '');
  return s.includes('/bidders/') && s.includes('/scan');
}

/**
 * Normalize a paper-invoice barcode by stripping leading zeros and dropping
 * the trailing check digit. Returns null for empty/invalid input or pick-sheet URLs.
 * @param {unknown} raw
 * @returns {string|null}
 */
export function parseInvoiceBarcode(raw) {
  const text = String(raw ?? '').trim();
  if (!text || isPickSheetScanUrl(text)) return null;
  if (!/^\d+$/.test(text)) return null;
  const withoutLeadingZeros = text.replace(/^0+/, '');
  if (withoutLeadingZeros.length < 2) return null;
  return withoutLeadingZeros.slice(0, -1);
}
